import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Translator, { __ } from "services/Translator";
import Slider from "react-slick";

import bannerOne600 from "assets/chilirojo/images/banners/banner-one-phone.webp";
import bannerOne900 from "assets/chilirojo/images/banners/banner-one-tab.webp";
import bannerOne1200 from "assets/chilirojo/images/banners/banner-one-middle.webp";
import bannerOne1600 from "assets/chilirojo/images/banners/banner-one-big.webp";




import homeBannerBg from "assets/chilirojo/images/banners/home-banner-big.webp";
import homeBannerBgMobile from "assets/chilirojo/images/banners/home-banner-mobile.webp";
import homeBannerBgMiddle from "assets/chilirojo/images/banners/home-banner-middle.webp";

// Import videos for big screens
import bannerOneVideo from "assets/chilirojo/videos/banner-one.mp4";

import homeBannerVideoWebm from "assets/chilirojo/images/banners/home-banner-animation.webm";
import homeBannerVideowebp from "assets/chilirojo/images/banners/home-banner-animation-safari.webp";

// VIP banner assets
import vipBannerDesktopMp4 from "assets/chilirojo/images/banners/vip-banner-desktop.mp4";
import vipBannerTablet from "assets/chilirojo/images/banners/vip-banner-tablet.webp";
import vipBannerPhone from "assets/chilirojo/images/banners/vip-banner-phone.webp";

export default function HomeFullBanner(props) {
  // Browser and device detection state
  const [isSafari, setIsSafari] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [screenSize, setScreenSize] = useState('desktop');

  // Detect Safari browser and screen size on component mount
  useEffect(() => {
    const userAgent = navigator.userAgent;
    const safariDetected = /^((?!chrome|android).)*safari/i.test(userAgent);
    setIsSafari(safariDetected);

    // Initial screen size detection
    const updateScreenSize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 767);

      if (width <= 600) {
        setScreenSize('mobile');
      } else if (width <= 900) {
        setScreenSize('tablet-small');
      } else if (width <= 1200) {
        setScreenSize('tablet-large');
      } else {
        setScreenSize('desktop');
      }
    };

    updateScreenSize();
    window.addEventListener('resize', updateScreenSize);

    return () => window.removeEventListener('resize', updateScreenSize);
  }, []);

  // Get responsive background image based on screen size
  const getResponsiveBackgroundImage = () => {
    switch (screenSize) {
      case 'mobile':
        return homeBannerBgMobile;
      case 'tablet-small':
        return homeBannerBgMobile;
      case 'tablet-large':
        return homeBannerBgMiddle;
      default:
        return homeBannerBg;
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    fade: true,
    cssEase: "linear",
  };

  return (
    <>
      {props.callFrom === "landing" && (
        <div className={`homeBannerFull ${props.isSidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'}`}>
          {/* <Slider {...settings}> */}
          <div
            className={`banner-container slideOne with-direct-image ${screenSize}`}
          >
            {/* Direct responsive image element */}
            <picture className="banner-image-container">
              <source
                srcSet={homeBannerBgMobile}
                media="(max-width: 600px)"
                type="image/webp"
              />
              <source
                srcSet={homeBannerBgMobile}
                media="(max-width: 900px)"
                type="image/webp"
              />
              <source
                srcSet={homeBannerBgMiddle}
                media="(max-width: 1200px)"
                type="image/webp"
              />
              <source
                srcSet={homeBannerBg}
                media="(min-width: 1201px)"
                type="image/webp"
              />
              <img
                src={getResponsiveBackgroundImage()}
                alt="Casino Banner"
                className="banner-img"
                loading="eager"
                decoding="async"
              />
            </picture>

            {/* Cross-browser transparent animation - responsive across all screen sizes */}
            <div className={`banner-video-container video-right-positioned ${screenSize}`}>
              {!isSafari ? (
                // WebM video for modern browsers
                <video
                  className={`banner-video video-right-style ${screenSize}`}
                  autoPlay
                  muted
                  loop
                  playsInline
                  style={{ background: 'transparent' }}
                >
                  <source src={homeBannerVideoWebm} type="video/webm" />
                  {/* Fallback to WebP if WebM fails */}
                  <img
                    src={homeBannerVideowebp}
                    alt="Casino Animation"
                    className={`banner-video video-right-style ${screenSize}`}
                    style={{ background: 'transparent' }}
                  />
                </video>
              ) : (
                // Animated WebP for Safari
                <img
                  src={homeBannerVideowebp}
                  alt="Casino Animation"
                  className={`banner-video video-right-style ${screenSize}`}
                  style={{ background: 'transparent' }}
                />
              )}
            </div>

            <div className={`bannerContent ${isMobile ? 'mobile-content' : ''}`}>
              <h1 className="orange">{__("Welcome To the heat")}</h1>
              <h1 className="white">{__("At Chile Rojo")}</h1>
              <p>
                {__(
                  "Sizzling slots with the highest payouts, live dealer action, crash games & more. Where every spin turns up the heat."
                )}
              </p>

              {!props.isAuthenticated && (
                <Link
                  onClick={() => {
                    props.setModalSignUpPropsData(true);
                    setTimeout(function () {
                      props.setModalSignUpPropsData(false);
                    }, 500);
                  }}
                  className="commonBtn pOneBtn"
                >
                  {__("Get Lucky Now!")}
                </Link>
              )}

              {props.isAuthenticated && (
                <Link
                  onClick={() => {
                    props.setDepositModal(true);
                    setTimeout(function () {
                      props.setDepositModal(false);
                    }, 500);
                  }}
                  className="commonBtn pOneBtn"
                >
                  {__("Deposit Now!")}
                </Link>
              )}
            </div>
          </div>

          {/* </Slider> */}
        </div>
      )}

      {props.callFrom === "vip" && (
        <div className={`homeBannerFull ${props.isSidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded'}`}>
          {/* <Slider {...settings}> */}
          <div
            className={`banner-container slideOne with-direct-image ${screenSize}`}
          >
            {/* VIP banner media: mobile/tablet use images, desktop uses MP4 */}
            <div className="banner-image-container">
              {screenSize === 'mobile' ? (
                <img
                  src={vipBannerPhone}
                  alt="VIP Banner"
                  className="banner-img"
                  loading="eager"
                  decoding="async"
                />
              ) : (screenSize === 'tablet-small' || screenSize === 'tablet-large') ? (
                <img
                  src={vipBannerTablet}
                  alt="VIP Banner"
                  className="banner-img"
                  loading="eager"
                  decoding="async"
                />
              ) : (
                <video
                  className="banner-img"
                  autoPlay
                  muted
                  loop
                  playsInline
                >
                  <source src={vipBannerDesktopMp4} type="video/mp4" />
                </video>
              )}
            </div>

            <div className={`bannerContent ${isMobile ? 'mobile-content' : ''}`}>
              <h1 className="orange">{__("FROM ROOKIE TO LEGEND")}</h1>
              <h1 className="white">{__("Chile Rojo VIP CLUB")}</h1>
              <p>
                {__(
                  "Our loyalty program rewards passion. Earn points on every spin, turn them into fiery perks, bonus buys, and exclusive rewards. At Chile Rojo, the longer you play, the hotter your rewards burn."
                )}
              </p>

              {!props.isAuthenticated && (
                <Link
                  onClick={() => {
                    props.setModalSignUpPropsData(true);
                    setTimeout(function () {
                      props.setModalSignUpPropsData(false);
                    }, 500);
                  }}
                  className="commonBtn pOneBtn"
                >
                  {__("Get Lucky Now!")}
                </Link>
              )}

              {props.isAuthenticated && (
                <Link
                  onClick={() => {
                    props.setDepositModal(true);
                    setTimeout(function () {
                      props.setDepositModal(false);
                    }, 500);
                  }}
                  className="commonBtn pOneBtn"
                >
                  {__("Deposit Now!")}
                </Link>
              )}
            </div>
          </div>

          {/* </Slider> */}
        </div>
      )}


    </>
  );
}
